// @ts-check
import { fetchJsonWithRetry } from "./FetchWithRetry.js";
import { loadGameList } from "./game_lists/GameListEntry.js";
import { redirectUrl } from "./Redirect.js";
import { initSentry } from "./Sentry.js";

/**
 * @typedef {Object} BuildConfiguration
 * @property {{
 *   staging: number,
 *   stage1: number,
 *   stage2: number,
 *   stage3: number,
 *   stage4: number
 * }} online
 * @property {{
 *   staging: number,
 *   stage1: number,
 *   stage2: number,
 *   stage3: number,
 *   stage4: number
 * }} onlineSelective
 * @property {{
 *   staging: string,
 *   production: string
 * }} jackpots
 */

console.log("index.js reached")
if (new URL(document.location.href).searchParams.get("addBreakpointAtRedirectsStart")) {
    new Function("debugger")();
}
initSentry();
console.log("Sentry started")

const redirectsConfigUrl = document.location.origin + "/redirects_configuration.json";

(async () => {
    /** @type {BuildConfiguration} */
    const buildsConfiguration = await fetchJsonWithRetry(redirectsConfigUrl);
    const gameList = await loadGameList();
    const url = new URL(document.location.href);
    const newUrl = redirectUrl(url, gameList, buildsConfiguration)
    document.location.replace(newUrl);
})();

